/**
 * Formats a `DecimalRangePredicate` (e.g. price/cap/discount bounds in an AI drafts-search filter) into a compact
 * operator-prefixed string for display in a chip — e.g. `{ gte: 100 }` → `"≥100"`. Only the first present operator
 * is rendered (precedence: gte, lte, gt, lt, eq, neq); an empty predicate yields `""`.
 *
 * Used by `summarizeServicePredicate.ts` and `ServicesChips/serviceConditionDisplay.ts` to render service price-like
 * conditions inside the services chip.
 */ const DECIMAL_OPERATORS = [
    'gte',
    'lte',
    'gt',
    'lt',
    'eq',
    'neq'
];
const OPERATOR_SYMBOL = {
    gte: '≥',
    lte: '≤',
    gt: '>',
    lt: '<',
    eq: '=',
    neq: '≠'
};
const primaryOperatorOf = (value)=>{
    var _DECIMAL_OPERATORS_find;
    return (_DECIMAL_OPERATORS_find = DECIMAL_OPERATORS.find((operator)=>(value === null || value === void 0 ? void 0 : value[operator]) != null)) !== null && _DECIMAL_OPERATORS_find !== void 0 ? _DECIMAL_OPERATORS_find : 'gte';
};
export const summarizeDecimalRange = (value)=>{
    const operator = primaryOperatorOf(value);
    const bound = value[operator];
    return bound != null ? "".concat(OPERATOR_SYMBOL[operator]).concat(bound) : '';
};
